import Cookies, { CookieAttributes } from 'js-cookie';

const cookieFns = {
  invoke: {
    get: ([key]: [string]) => {
      return Cookies.get(key);
    },
    has: ([key]: [string]) => {
      return !!Cookies.get(key);
    },
    remove: ([key]: [string]) => {
      return Cookies.remove(key);
    },
    set: ([key, value, options]: [string, any, CookieAttributes]) => {
      return Cookies.set(key, value, options);
    },
  },
};

export default cookieFns;
